// This utility exports a promise that resolves when the storage is ready.
let readyResolve;

export function resolveStorageReadyHandler() {
  readyResolve(); // To be called when storage is ready for awaited promise usages
}

export const storageReadyPromise = new Promise((resolve) => {
  readyResolve = resolve; // Retain the resolve function to be awaited on when storage is ready
});
